export const LoaderType = {
  FETCH: 'fetch',
  XHR: 'xhr'
}

export const ResponseType = {
  ARRAY_BUFFER: 'arraybuffer',
  TEXT: 'text',
  JSON: 'json'
}
